import Button from '@mui/material/Button';
import MessageBox from './MessageBox';
import React from 'react';

const VerifyEmailSuccess = () => {
  return (
    <MessageBox
      header="Success!"
      message="You've finished verifying your email address."
      secondaryMessage={
        <Button
          color="secondary"
          style={{ width: '100%' }}
          onClick={ () => window.location.href = '/' }
        >
          Login
        </Button>
      }
    />
  )
}

export default VerifyEmailSuccess;
